import { render } from "./NavbarComp.vue?vue&type=template&id=00493225&scoped=true"
import script from "./NavbarComp.vue?vue&type=script&lang=js"
export * from "./NavbarComp.vue?vue&type=script&lang=js"

import "./NavbarComp.vue?vue&type=style&index=0&id=00493225&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00493225"]])

export default __exports__